import React from 'react';
import { Drawer, IconButton, Divider, List, Box } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';

import { useStyles } from './styles';
import DrawerList, { mainListItems } from './DrawerList';
import { useLayoutState, useLayoutDispatch, toggleSidebar } from 'context/LayoutContext';
import { ISlider } from 'types/Navigation/NavigationStructure';
import LogoCavca from 'assets/Branding/cavcaLogoV2White.png';

const SideDrawer: React.FC<{ slider?: ISlider[] }> = ({ slider }) => {
  const classes = useStyles();

  const { isSidebarOpened } = useLayoutState();
  const layoutDispatch = useLayoutDispatch();

  const handleDrawerClose = () => {
    toggleSidebar(layoutDispatch);
  };

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: clsx(classes.drawerPaper, !isSidebarOpened && classes.drawerPaperClose),
      }}
      open={isSidebarOpened}>
      <Box className={classes.containerBox}>
        <div className={classes.containerLogo}>
          <img className={classes.logo} src={LogoCavca} alt="logo" />
        </div>
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <MenuIcon className={classes.menuIcon} />
          </IconButton>
        </div>
      </Box>

      <Divider />
      {slider ? (
        <List>
          {slider.map((item) => (
            <DrawerList key={item.id} {...item} />
          ))}
        </List>
      ) : (
        <List>{mainListItems}</List>
      )}
    </Drawer>
  );
};

export default SideDrawer;
